<template>
  <v-card>
    <v-card-title>{{ editingUserAuth.name }}</v-card-title>
    <v-card-text>
      <v-row
        v-for="(mapUserAuthSite, index) in editingUserAuth.mapUserAuthSites"
        :key="index"
      >
        <v-col cols="2">
          {{ mapUserAuthSite.site.name }}
        </v-col>
        <MasterAdminPermissionGuardContainer>
          <v-col cols="2" class="text-center">
            <v-btn
              outlined
              small
              color="error"
              @click="
                deleteUserAuthSite(editingUserAuth.id, mapUserAuthSite.site)
              "
            >
              削除
            </v-btn>
          </v-col>
        </MasterAdminPermissionGuardContainer>
        <v-col cols="3">
          <v-tooltip bottom max-width="200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="mapUserAuthSite.siteUser.canCommunicateWithClient"
                color="primary"
                tile
                small
                v-bind="attrs"
                v-on="on"
                @click="
                  updateUserCanCommunicateWithClient(
                    editingUserAuth.id,
                    mapUserAuthSite.site.siteKey,
                    mapUserAuthSite.siteUser.canCommunicateWithClient
                  )
                "
              >
                共有を停止する
              </v-btn>
              <v-btn
                v-else
                color="normal"
                tile
                small
                :disabled="!mapUserAuthSite.siteUser.displayCommonInformation"
                v-bind="attrs"
                v-on="on"
                @click="
                  updateUserCanCommunicateWithClient(
                    editingUserAuth.id,
                    mapUserAuthSite.site.siteKey,
                    mapUserAuthSite.siteUser.canCommunicateWithClient
                  )
                "
              >
                共有を可能にする
              </v-btn>
            </template>
            <span style="display: block; font-size: 10px; line-height: 13px">
              クライアントがこのライターに発注を直接行えるようになります。また、メールアドレスが公開されます。
            </span>
          </v-tooltip>
        </v-col>
        <v-col cols="5" style="text-align: right">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="mapUserAuthSite.siteUser.displayCommonInformation"
                color="primary"
                tile
                small
                :disabled="mapUserAuthSite.siteUser.canCommunicateWithClient"
                v-bind="attrs"
                v-on="on"
                @click="
                  updateUserDisplayCommonInformation(
                    editingUserAuth.id,
                    mapUserAuthSite.site.siteKey,
                    mapUserAuthSite.siteUser.displayCommonInformation
                  )
                "
              >
                プロフィールを非公開にする
              </v-btn>
              <v-btn
                v-else
                color="normal"
                tile
                small
                v-bind="attrs"
                v-on="on"
                @click="
                  updateUserDisplayCommonInformation(
                    editingUserAuth.id,
                    mapUserAuthSite.site.siteKey,
                    mapUserAuthSite.siteUser.displayCommonInformation
                  )
                "
              >
                プロフィールを公開する
              </v-btn>
            </template>
            <span style="display: block; font-size: 10px; line-height: 13px">
              クライアントにライターのプロフィール情報が公開され、メディア内でも
              ライタープロフィールやライターページの公開が可能になります。ただし、
              メールアドレスは公開されず、クライアントが直接発注することはできません。
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
      <MasterAdminPermissionGuardContainer>
        <v-row>
          <v-col cols="8">
            <v-card-text>
              <v-select
                v-model="selectedAddSiteKey"
                :items="selectableSiteKeys"
                item-text="name"
                item-value="id"
              />
            </v-card-text>
          </v-col>
          <v-col cols="4" class="text-center">
            <v-btn
              color="primary"
              @click="addUserAuthSite(editingUserAuth.id, selectedAddSiteKey)"
              >追加</v-btn
            >
          </v-col>
        </v-row>
      </MasterAdminPermissionGuardContainer>
    </v-card-text>
  </v-card>
</template>

<script>
import MasterAdminPermissionGuardContainer from '/src/container/shared/MasterAdminPermissionGuardContainer'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  components: { MasterAdminPermissionGuardContainer },
  props: {
    editingUserAuth: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      allSiteKeys: [],
      selectedAddSiteKey: null
    }
  },
  computed: {
    selectableSiteKeys () {
      const rejectKeys = []
      if (this.editingUserAuth.mapUserAuthSites) {
        this.editingUserAuth.mapUserAuthSites.forEach((object) => {
          rejectKeys.push(object.site.siteKey)
        })
      }

      const tmp = []
      this.allSiteKeys.forEach((object) => {
        if (!rejectKeys.includes(object.siteKey)) {
          tmp.push(object)
        }
      })
      return tmp
    }
  },
  mounted: function () {
    axios.get(`/api/master/sites`).then((data) => {
      this.allSiteKeys = deserialize(data.data).data
    })
  },
  methods: {
    deleteUserAuthSite (userAuthId, site) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .delete(`/api/master/user_auths/${userAuthId}/sites/${site.id}`)
        .then(
          (data) => {
            this.$emit('deleteEditingUserAuthSite', site.id)
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: 200,
              message: data.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.statusText
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    addUserAuthSite (userAuthId, siteId) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios.patch(`/api/master/user_auths/${userAuthId}/sites/${siteId}`).then(
        (data) => {
          this.$emit('updateEditingUserAuth', deserialize(data.data).data)
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: 200,
            message: 'サイトを追加しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.statusText
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
      this.selectedAddSiteKey = null
    },
    updateUserCanCommunicateWithClient (
      userAuthId,
      siteKey,
      userCanCommunicateWithClient
    ) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/master/user_auths/${userAuthId}/users`, {
          site_key: siteKey,
          user: {
            can_communicate_with_client: !userCanCommunicateWithClient
          }
        })
        .then(
          (data) => {
            this.$emit(
              'updateEditingUserAuthUser',
              deserialize(data.data).data,
              siteKey
            )
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: 200,
              message: '保護情報を更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.statusText
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    updateUserDisplayCommonInformation (
      userAuthId,
      siteKey,
      userDisplayCommonInformation
    ) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/master/user_auths/${userAuthId}/users`, {
          site_key: siteKey,
          user: {
            display_common_information: !userDisplayCommonInformation
          }
        })
        .then(
          (data) => {
            this.$emit(
              'updateEditingUserAuthUser',
              deserialize(data.data).data,
              siteKey
            )
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: 200,
              message: '保護情報を更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.statusText
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>
